$(document).on('click', '.fix-content-add-row', function () {
  var container = $($(this).data('target'));
  var row = container.find('.fix-content-row').first();

  container.find('select').selectpicker('destroy');

  var clone = row.clone();
  clone.find('select').val('');
  clone.find('input[type="number"]').val('');
  container.append(clone);

  container.find('select').selectpicker();
});
